import v2 from './v2';
import v1 from './v1';

const routerConfig = [...v1, ...v2];

export default routerConfig;
